module.exports = __webpack_public_path__ + "static/media/videoBadgeLevel5Locked.69e1c595.png";